import {HttpConfig} from './http-config.interface';

export const httpDefaultConfig: HttpConfig = {
    uri: '/'
}